import axiosRepdPublic from "../axiosConfig"

// TODO(endpoints): cambiar firma a fetchCardData(moduleType) y rutear por módulo
// cuando backend publique endpoints distintos para cards CI/CLB.
export const fetchCardData = () => 
    axiosRepdPublic.get(`version_publica/datos_para_home/`)
